import { FlagsProvider, ReactQueryProvider, RouterProvider } from "./providers";
import { Spinner } from "./components/Common/Spinner";
import { TooltipProvider } from "./providers/Tooltip.provider";
import { TimeDisplayModeProvider } from "@/components/Common/TimeDisplay";
import { DeltaDisplayModeProvider } from "@/components/Common/DeltaDisplay";
import { useCallback, useEffect } from "react";
import { useStore } from "@/stores/useStore";
import { HeaderProvider } from "@/providers/Header.provider";
import { CardMetricsOptionsProvider } from "@/providers/CardMetricsOptions.provider";
import { TerminologyProvider } from "@/providers/Terminology.provider";
import { NewVersionAvailableDialog } from "@/components/Dialogs/NewVersionAvailableDialog";
import { PerformanceMonitor } from "@/components/Common/PerformanceMonitor";
import { useAnalytics } from "@/hooks/useAnalytics";
import { config } from "@/config";
import { useTickerStore } from "@/stores/useTickerStore";
import { useServerClockSync } from "@/hooks/useServerClockSync";
import { InboxPanelProvider } from "@/providers/InboxPanel.provider";

export const App = () => {
  const { authListener, initialized } = useStore();
  const startTicker = useTickerStore((s) => s.startTicker);
  useAnalytics();

  const authListenerCallback = useCallback(
    () => authListener(),
    [authListener]
  );

  useEffect(() => {
    authListenerCallback();
  }, [authListenerCallback]);

  const startTickerCallback = useCallback(() => startTicker(), [startTicker]);

  useEffect(() => {
    startTickerCallback();
  }, [startTickerCallback]);

  useServerClockSync();

  if (!initialized) {
    return (
      <div className="flex h-screen flex-col overscroll-none">
        <div className="relative flex flex-grow overflow-hidden border-2 bg-background">
          <main className="flex flex-1 flex-grow flex-col overflow-x-auto overflow-y-auto bg-slate-900 text-slate-100">
            <div className="m-auto">
              <Spinner />
            </div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <ReactQueryProvider>
      <FlagsProvider>
        <TooltipProvider>
          <TerminologyProvider>
            <TimeDisplayModeProvider>
              <DeltaDisplayModeProvider>
                <CardMetricsOptionsProvider>
                  <InboxPanelProvider>
                    <HeaderProvider>
                      <RouterProvider />
                      <NewVersionAvailableDialog />
                      {config.mode === "emulator" && <PerformanceMonitor />}
                    </HeaderProvider>
                  </InboxPanelProvider>
                </CardMetricsOptionsProvider>
              </DeltaDisplayModeProvider>
            </TimeDisplayModeProvider>
          </TerminologyProvider>
        </TooltipProvider>
      </FlagsProvider>
    </ReactQueryProvider>
  );
};
